import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

type PropsType = {
  label?: string;
  options: { [key: string]: string };
  value?: string;
  onChange?: (key: string) => void;
  disabled?: boolean;
};

function DropdownInput(props: PropsType) {
  return (
    <FormControl fullWidth>
      {props.label !== null && <InputLabel>{props.label}</InputLabel>}
      <Select
        disabled={props.disabled ?? false}
        value={props.value}
        label={props.label}
        onChange={(e) => {
          if (props.onChange) props.onChange(e.target.value as string);
        }}
      >
        {Object.entries(props.options).map((entry) => (
          <MenuItem key={entry[0]} value={entry[0]}>
            {String(entry[1])}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DropdownInput;
